export default __webpack_public_path__ + "static/latitude-28-degrees-7801cdfcf239ee41b75c64ad78d07747.png";